import * as React from 'react';
import type { FieldFormProps } from '@helpcenter/field-types';
import type { FieldOption } from '@helpcenter/form-select';
import { FormAsyncCreatableMultiSelect } from '@helpcenter/form-select';
import type { ValueType } from '@atlaskit/select/types';
import { toMultiSelectValue } from '@atlassian/help-center-common-util/select';

export type LabelPickerOption = FieldOption<string>[];

export interface Props extends FieldFormProps<string[] | string> {
	defaultLabels?: LabelPickerOption;
	loadOptions: (inputValue: string, callback: (options: LabelPickerOption) => void) => void;
	validationErrorMessage?: string;
	valueOverride?: LabelPickerOption;
}

interface State {
	selectedOption: LabelPickerOption;
}

export default class LabelPickerDumb extends React.PureComponent<Props, State> {
	state: State = {
		selectedOption: this.props.defaultLabels as LabelPickerOption,
	};

	componentDidMount() {
		// PORTAL-2032 - this is required to make url filling (e.g. ?customfield_10343=10657) work
		if (this.props.defaultLabels && this.props.defaultLabels.length > 0) {
			this.onChange(this.props.defaultLabels as unknown as ValueType<FieldOption<string>>);
		}
	}

	isValidNewOption = (inputValue: string, _: string, existingLabels: LabelPickerOption) => {
		if (!!this.props.validationErrorMessage) {
			return false;
		}

		if (inputValue === '') {
			return false;
		}

		if (!Array.isArray(existingLabels)) {
			return false;
		}

		const isLabelAlreadyExisting = existingLabels.some((label) => label.value === inputValue);
		return !isLabelAlreadyExisting;
	};

	onChange = (value: ValueType<FieldOption<string>>) => {
		const { id, onChange } = this.props;
		const selectedValue = toMultiSelectValue(value);
		// The labels field requires that you pass the a value in the create request
		// lest Jira applies the default labels to it.
		const val = selectedValue.length !== 0 ? selectedValue.map((v) => v.value) : '';
		onChange?.(id, val, false, { rawObject: {}, rawValue: selectedValue });
	};

	render() {
		const { label, disabled, ...otherProps } = this.props;

		const errorMessage = this.props.validationErrorMessage ?? this.props.errorMessage;
		return (
			<FormAsyncCreatableMultiSelect
				{...otherProps}
				actionSubjectId="labelPickerField"
				label={label ?? ''}
				isDisabled={disabled}
				onChange={this.onChange}
				loadOptions={this.props.loadOptions}
				defaultValue={this.state.selectedOption}
				isValidNewOption={this.isValidNewOption}
				errorMessage={errorMessage}
			/>
		);
	}
}
